/*! PNM Picker Entry — product + cart triggers */
(function () {
  'use strict';

  function host() {
    return document.getElementById('pnm-picker-root');
  }

  function dispatch(eventName, detail) {
    var root = host();
    if (!root) return false;
    try {
      root.dispatchEvent(
        new CustomEvent(eventName, { detail: detail || {}, bubbles: false })
      );
      return true;
    } catch (_) {
      return false;
    }
  }

  function bindLaunch() {
    var btn = document.getElementById('advent-picker-launch');
    if (!btn || btn._pnmBound) return;
    btn._pnmBound = true;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      dispatch('pnm:open', { mode: 'product' });
    });
  }

  function parseChildKeys(container) {
    if (!container) return [];
    var raw = container.getAttribute('data-advent-children');
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
    } catch (_) {}
    return [];
  }

  function bindEditLinks() {
    var links = document.querySelectorAll('.advent-picker-edit');
    if (!links || !links.length) return;
    links.forEach(function (link) {
      if (link._pnmBound) return;
      link._pnmBound = true;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var container = link.closest('.cart-item-container');
        var detail = {
          key: link.getAttribute('data-key') || '',
          scents: link.getAttribute('data-scents') || '',
          group: container
            ? container.getAttribute('data-advent-group') || ''
            : '',
          childKeys: parseChildKeys(container),
        };
        dispatch('pnm:edit', detail);
      });
    });
  }

  function init() {
    if (!host()) return;
    bindLaunch();
    bindEditLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
